// getModalData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select modal data by id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - modal id.
 * @param {string} dataKey - data key.
 * @return {any} The selected modal data.
 */
const getModalData = createCachedSelector(
  state => state.get('modals'),
  (state, id) => id,
  (state, id, dataKey) => dataKey,
  (modals, id, dataKey) => {
    if (id === 'hasModal') {
      // Test if there's ANY modal.
      return modals.filter(modal => modal.get('status') === 'display').size > 0;
    }

    const result = modals?.getIn([id, dataKey]);
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, id, dataKey) => `${id}:${dataKey}`);

export default getModalData;
